const FirebaseSM = require("./src/firebaseSM");
module.exports = FirebaseSM;

//npm install @ecoenghk/firebaseweb

// update github
//npm version patch
//npm publish
